import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

import { IDIOMAS, LOCAL_STORAGE_IDIOMA } from './utils/constantes.js';

const idioma = localStorage.getItem(LOCAL_STORAGE_IDIOMA) || IDIOMAS.CATALAN;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: idioma,
    fallbackLng: idioma,
    backend: {
      loadPath: '/lang/{{lng}}/traduccion.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;